import type { PlantafelVisibleWeekdays } from './plantafelSettings';

export function weekdayFromAbsoluteIndex(absoluteIndex: number): number {
  return ((absoluteIndex % 7) + 7) % 7;
}

export function isAbsoluteDayVisible(absoluteIndex: number, visible: PlantafelVisibleWeekdays): boolean {
  return visible.includes(weekdayFromAbsoluteIndex(absoluteIndex));
}

/** Map absolute day offset (viewport starts Monday) to visible column index, or null if hidden. */
export function absoluteToVisibleColumn(
  absoluteIndex: number,
  visible: PlantafelVisibleWeekdays,
): number | null {
  const dow = weekdayFromAbsoluteIndex(absoluteIndex);
  const pos = visible.indexOf(dow);
  if (pos < 0) return null;
  const week = Math.floor(absoluteIndex / 7);
  return week * visible.length + pos;
}

export function clipSpanToVisibleColumns(
  dayStart: number,
  dayEnd: number,
  visible: PlantafelVisibleWeekdays,
): { colStart: number; colEnd: number } | null {
  let colStart: number | null = null;
  let colEnd: number | null = null;
  for (let d = dayStart; d <= dayEnd; d++) {
    const col = absoluteToVisibleColumn(d, visible);
    if (col == null) continue;
    if (colStart == null) colStart = col;
    colEnd = col;
  }
  if (colStart == null || colEnd == null) return null;
  return { colStart, colEnd };
}

export function visibleColumnCount(visible: PlantafelVisibleWeekdays, weekCount = 1): number {
  return visible.length * weekCount;
}

export function visibleColumnToAbsoluteDay(colIndex: number, visible: PlantafelVisibleWeekdays): number {
  const week = Math.floor(colIndex / visible.length);
  const dow = visible[colIndex % visible.length] ?? visible[0];
  return week * 7 + dow;
}

export function weekDayWidthPct(visible: PlantafelVisibleWeekdays): number {
  return 100 / Math.max(visible.length, 1);
}
